import { IV3D } from '@/Interfaces/v3d';
import { Material, Plane, Vector3, Box3, Quaternion } from 'three';
import { V3dTools } from '@/v3d/common';
import { doorDepth, windowOffset } from '@/Constants/common';
import changeColor from '@/utils/changeColor';
import { sides, v3dMesh, xyz } from '@/Interfaces/common';
import { $ } from '@/Engine/stateInstance';
import { WardrobeObject } from '@/Engine/Wardrobe/WardrobeObject';

declare let v3d: IV3D;
export interface WindowProps {
    // app: iApp;
    width: number;
    height: number;
    // wall: v3dMesh;
    side: sides;
    name: string;
    // transparent: boolean;
    color: string;
    uuid: string;
}

export class Window extends WardrobeObject{
    private v3dTools: V3dTools;
    clipPlanes: Array<Plane> = [];
    public box: Box3 = new Box3();
    _model: v3dMesh | null = null;

    set position(pos: Vector3) {
        this.model.position.copy(pos);
        this._updateBox();
        // Было для x -0.01 не помню почему
        this.computeObb();
    }

    get position() {
        return this.model.position;
    }

    get startPoint(): xyz {
        return [
            -this.width/2,
            -this.height/2,
            0,
        ];
    }

    constructor({ uuid, width, height, name, color } : WindowProps) {
        super({ width, height, depth: doorDepth, uuid, type: 'window' });
        // this.side = side;
        this.v3dTools = $.v3dTools;

        const model = this.v3dTools.getObjectByName(name);

        if (!model) {
            console.error('Не найдена модель окна ' + name);
            return;
        }
        this._model = model.clone() as v3dMesh;
        this._model.userData.parent = this;
        this._model.visible = true;
        this._model.position.set(...windowOffset);
        this.model.add(this._model);
        this.updateModelShapeKey();
        this.setColor(color);
    }

    updateModelShapeKey() {
        if (!this._model) return;

        this.v3dTools.setMorphFactorByItem(
            this._model,
            'height',
            this.height - 1.17,
        );
        this.v3dTools.setMorphFactorByItem(
            this._model,
            'width',
            this.width - 0.5,
        );
        this._updateBox();
        this.computeObb();
    }

    setPosition(position: Vector3) {
        this.position = position;

        const modelWorldPosition = new Vector3(0,0,0);
        this.model.getWorldPosition(modelWorldPosition);

        this.updateModelShapeKey();
    }

    materialModifier(material: Material) {
        if (!material.clippingPlanes)
            material.clippingPlanes = this.clipPlanes;
        else {
            material.clippingPlanes = [ ...material.clippingPlanes, ...this.clipPlanes ];
        }
        material.clipIntersection = true;
    }

    setColor(hex: string) {
        if (this._model)
            changeColor(this._model, 'RGB', hex);
    }

    setDimensions(width: number, height: number) {
        this.width = width;
        this.height = height;
        this.updateModelShapeKey();
        // console.log(this.selectionBox?.target?.uuid, this.uuid);
        // if (this.selectionBox && this.selectionBox.target?.uuid === this.uuid) this.select();
    }

    _updateBox() {
        this.box.makeEmpty();

        if (!this.model.parent) return;

        const dimesnions = new Vector3(this.width, this.height, this.depth);
        const quatern = new Quaternion();
        this.model.getWorldQuaternion(quatern);
        dimesnions.applyQuaternion(quatern);
        dimesnions.x = Math.abs(dimesnions.x);
        dimesnions.y = Math.abs(dimesnions.y);
        dimesnions.z = Math.abs(dimesnions.z);
        const worldPosition = new Vector3();
        this.model.getWorldPosition(worldPosition);
        this.box.setFromCenterAndSize(this.model.position, dimesnions);
    }
    computeObb() {
        const worldQuaternion = new Quaternion();
        this.model.getWorldQuaternion(worldQuaternion);
        const centerShift = new Vector3(0,0, this.depth/2).applyQuaternion(worldQuaternion);
        this.worldBox = this.box.clone().applyMatrix4(this.model.matrixWorld);
        super.computeObb(centerShift, 0.0001);
    }
}
